import * as types from "./mutation-types";
import { realtorsService } from "@/services";
import { messageHelper } from "@/helpers/message_helper";

export const fetchRealtorList = async ({ commit }, params) => {
  commit(types.SET_IS_LOADING, true);

  try {
    const response = await realtorsService.list(params);
    commit(types.SET_REALTOR_LIST, response.data.data);
    if (params.realEstateId) {
      commit(types.SET_TOTAL_ITEMS, response.data.meta.count);
    }
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  } finally {
    commit(types.SET_IS_LOADING, false);
  }
};

// eslint-disable-next-line no-unused-vars
export const getRealtorById = async ({ commit }, payload) => {
  let realtor = {};

  try {
    const response = await realtorsService.getById(payload);
    realtor = response.data.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }

  return realtor;
};

// eslint-disable-next-line no-unused-vars
export const getEventsById = async ({ commit }, payload) => {
  let events = {};

  try {
    const response = await realtorsService.getEventsById(payload);
    events = response.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }

  return events;
};

// eslint-disable-next-line no-unused-vars
export const getRealtorEventsById = async ({ commit }, payload) => {
  let events = {};

  try {
    const response = await realtorsService.getRealtorEventsById(payload);
    events = response.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }

  return events;
};

export const updateRealtorSearch = async ({ commit }, payload) => {
  commit(types.SET_REALTOR_SEARCH, payload);
};

export const approveRealtor = async ({ commit }, realtorId) => {
  var success = false;

  try {
    const response = await realtorsService.approve(realtorId);
    commit(types.UPDATE_REALTOR_IN_LIST, response.data.data);
    success = true;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }

  return success;
};

export const rejectRealtor = async ({ commit }, realtorId) => {
  try {
    const response = await realtorsService.reject(realtorId);
    commit(types.UPDATE_REALTOR_IN_LIST, response.data.data);

    messageHelper.displaySuccess("Corretor rejeitado com sucesso.");
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro ao rejeitar o corretor.");
  }
};

export const lockRealtor = async ({ commit }, realtorId) => {
  try {
    const response = await realtorsService.lock(realtorId);
    commit(types.UPDATE_REALTOR_IN_LIST, response.data.data);

    messageHelper.displaySuccess("Corretor bloqueado com sucesso.");
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro ao bloquear o corretor.");
  }
};

// eslint-disable-next-line no-unused-vars
export const createRealtor = async ({ commit }, payload) => {
  let realtor = null;

  try {
    const response = await realtorsService.create(payload);
    realtor = response.data.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }

  return realtor;
};

// eslint-disable-next-line no-unused-vars
export const updateRealtor = async ({ commit }, payload) => {
  let realtor = null;

  try {
    const response = await realtorsService.update(payload);
    realtor = response.data.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }

  return realtor;
};
